module.exports = __webpack_public_path__ + "eff4fc2724114e7319df67d11e411783.svg";